import { render, staticRenderFns } from "./ThgImpactSelector.vue?vue&type=template&id=808fd198&scoped=true&"
import script from "./ThgImpactSelector.vue?vue&type=script&lang=ts&"
export * from "./ThgImpactSelector.vue?vue&type=script&lang=ts&"
import style0 from "./ThgImpactSelector.vue?vue&type=style&index=0&id=808fd198&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "808fd198",
  null
  
)

export default component.exports